import { styled } from "@vitality-ds/system";
import BaseNumberTextCellStyles from "./styles/BaseNumberTextCell.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseNumberTextCell = styled("div", BaseNumberTextCellStyles);